import { useState } from "react";
import { searchCustomer } from "src/apis/customerApi";
import useUiuxStore from "src/store/useUiuxStore";
import { defaultPUR2010_R01Filter, usePUR2010_R01Store } from "src/containers/mes/PUR/PUR2010_R01/Store_PUR2010_R01";
import { SearchCodeModalForm } from "src/components/common/form/search/SearchCodeModalForm";
import { SearchDateRangeForm } from "src/components/common/form/search/SearchDateRangeForm";
import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { InfoCodeSearchFieldConfig } from "src/types/info-form";
import { useInfoFormEvents } from "src/hooks/useInfoFormEvents";

interface Props {
  onEnterKeyDown: () => void;
}

export const SearchSection_PUR2010_R01 = (props: Props) => {
	const { onEnterKeyDown } = props;
	const { PUR2010_R01Filter, setPUR2010_R01Filter } = usePUR2010_R01Store();
	const { setCodeSearchModalProps } = useUiuxStore();

	const [pickerVisible, setPickerVisible] = useState(false);
	const [pickerPosition, setPickerPosition] = useState<{ top: number; left: number }>({ top: 0, left: 0 });

	const custInfoHandleFoucsId = 'infoCustInput_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custInfoHandleFoucsId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
			},
			searchFunction: async (searchText: string) => {
				const customerResponse = await searchCustomer(searchText);
				return customerResponse.data.data.find(value => value.customCd === searchText);
			}
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: PUR2010_R01Filter,
		setEditData: setPUR2010_R01Filter,
		defaultData: defaultPUR2010_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'PUR2010_R01_search'
	});

	return (
		<SearchSectionForm>
			<SearchDateRangeForm
				label="매입 조회 기간"
				wrapperOption={{
					titleStyle: 'h-[24px] flex items-center truncate shrink-0 w-[80px] min-w-[80px]',
				}}
				visible={pickerVisible}
				setVisible={setPickerVisible}
				dateRange={PUR2010_R01Filter.dateRange}
				setDateRange={(dateRange) => setPUR2010_R01Filter({ dateRange })}
				pickerPosition={pickerPosition}
				setPickerPosition={setPickerPosition}
			/>

			<SearchCodeModalForm
				label="거래처"
				value={PUR2010_R01Filter.customCd}
				valueLabel={PUR2010_R01Filter.customNm}
				handleFoucsId={custInfoHandleFoucsId}
				onChange={getFieldHandlers('customCd').onChange}
				onDoubleClick={getFieldHandlers('customCd').onDoubleClick}
				onKeyDown={getFieldHandlers('customCd').onEnterKeyDown}
			/>
		</SearchSectionForm>
	);
};

export default SearchSection_PUR2010_R01;